import { Stack, Typography } from "@mui/material";

export default function DialogTitle() {
	return (
		<Stack gap={2} sx={{ p: 3 }}>
			<Typography alignSelf='center' textAlign={"center"} variant='h6'>
				{"¿Estas seguro que quieres eliminar estas transacciones?"}
			</Typography>
			<Typography alignSelf='center' textAlign={"center"} variant='subtitle2'>
				{"Se perderá toda la información de ellas."}
			</Typography>
		</Stack>
	);
}
